import { NgIf } from '@angular/common';
import {Component, Inject} from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RippleDirective } from '../../ripple.directive';

@Component({
  selector: 'app-error-modal',
  template: `
      <header class="error-dialog">
          <h1 mat-dialog-title><i class="bhi-caution"></i>
              <span class="title-info">
                  <span class="title-text">{{ data.title }}</span>
                  <span class="sub-info">{{ data.time }}</span>
              </span>
          </h1>
      </header>
      <div mat-dialog-content class="grid-2">
          <h2>{{ data.errorMessage }}</h2>
          <p *ngIf="data.cause">{{ data.cause }}</p>
      </div>
      <section mat-dialog-actions class="footer-btns">
          <button mat-button (click)="close()" theme-style="nav" appRipple>OK</button>
      </section>
  `,
  imports: [
    MatDialogContent,
    MatDialogTitle,
    MatDialogActions,
    MatButton,
    NgIf,
    RippleDirective
  ],
  styleUrls: ['./error-modal.component.scss']
})
export class ErrorModalComponent {
  constructor(
    public dialogRef: MatDialogRef<ErrorModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    if (!data.title)
      data.title = 'Data Rules: Unexpected error';
    data.time = new Date().toUTCString();
  }

  close(): void {
    this.dialogRef.close();
  }
}
